<template>
  <div id="shipments">
    <BreadCrumb :items="breadcrumbItems" />
    <v-card elevation="1" class="mt-1" :loading="loading">
      <div class="d-flex px-5 pt-5 justify-space-between align-center">
        <h1>Gerenciamento de embarques</h1>
      </div>

      <div class="mt15"></div>

      <v-expansion-panels class="px-5 py-1" accordion>
        <v-expansion-panel class="elevation-1">
          <v-expansion-panel-header color="#f2f2f2" class="px-4">
            <span>Filtrar por</span>
            <template v-slot:actions>
              <v-icon color="black"> mdi-chevron-down </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="mt-2 pb-1">
              <v-col cols="12" md="2">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedStartAuthDate"
                      label="Data autorização início"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="initialAuthDate"
                    :active-picker.sync="activePicker"
                    @change="save"
                    locale="pt-br"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedEndAuthDate"
                      label="Data autorização fim"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="endAuthDate"
                    :active-picker.sync="activePicker1"
                    @change="save1"
                    locale="pt-br"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="stateId"
                  label="Estado de Entrega"
                  :items="states"
                  item-text="name"
                  item-value="id"
                  @change="fetchCitiesByID"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="cityId"
                  label="Município de Entrega"
                  :items="cities"
                  item-text="name"
                  item-value="id"
                  @change="saveCityId()"
                  :disabled="!stateId"
                  :loading="loadingCity"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="hasReceiptFilter"
                  label="Possui Canhoto"
                  :items="hasReceiptOptions"
                  @change="saveHasReceipt()"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="isReceiptValidFilter"
                  label="Canhoto Validado"
                  :items="isReceiptValidOptions"
                  @change="saveIsReceiptValid()"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="isReceiptDownloaded"
                  label="Canhoto Baixado"
                  :items="booleanOptions"
                  @change="saveIsReceiptDownloaded()"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="isReceiptPurged"
                  label="Canhoto Expurgado"
                  :items="booleanOptions"
                  @change="saveIsReceiptPurged()"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="isTransferred"
                  label="Transferido"
                  :items="isTransferredOptions"
                  @change="saveIsTransferred()"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  class="auto-complete"
                  v-model="transhipmentId"
                  label="Transbordo"
                  :items="transhipments"
                  item-text="name"
                  item-value="id"
                  @change="saveTranshipmentId()"
                  clearable
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="senderId"
                  :items="senders"
                  item-text="name"
                  item-value="id"
                  label="Remetente"
                  @change="saveSenderId()"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="recipient" label="Destinatário" @change="saveRecipientName()"></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-select
                  v-model="status"
                  :items="statusList"
                  item-text="name"
                  item-value="id"
                  label="Status"
                  small-chips
                  deletable-chips
                  multiple
                  @change="saveStatus()"
                ></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-combobox
                  v-model="boardingNumber"
                  :search-input.sync="boardingNumberInput"
                  label="Número externo da Carga"
                  append-icon=""
                  hide-selected
                  multiple
                  chips
                  deletable-chips
                  @keydown.native="filterInput"
                  @change="saveBoardingNumber"
                ></v-combobox>
              </v-col>
              <v-col cols="12" md="4">
                <v-combobox
                  v-model="numberCTE"
                  :search-input.sync="cteNumberInput"
                  label="Número CTE"
                  append-icon=""
                  hide-selected
                  multiple
                  chips
                  deletable-chips
                  @keydown.native="filterInput"
                  @change="saveCteNumber"
                ></v-combobox>
              </v-col>
              <v-col cols="12" md="4">
                <v-combobox
                  v-model="keyNfe"
                  :search-input.sync="keyNfeInput"
                  append-icon=""
                  label="Número da Nota Fiscal"
                  hide-selected
                  multiple
                  chips
                  deletable-chips
                  @keydown.native="filterInput"
                  @change="saveNfeNumber"
                ></v-combobox>
              </v-col>

              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="courierId"
                  :loading="isCouriersLoading"
                  class="auto-complete"
                  label="Entregador"
                  :items="couriers"
                  item-text="name"
                  item-value="id"
                  @change="saveCourierId()"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field v-model="boardingId" label="Id do Embarque" @change="saveBoardingId()"></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="numberInvoiceId"
                  label="Id da Fatura"
                  @change="saveNumberInvoiceId()"
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="d-flex justify-end align-center">
                <v-btn elevation="2" color="info" @click="openExportReportDialog"> EXPORTAR DADOS </v-btn>

                <v-btn
                  :disabled="!hasFilters"
                  elevation="2"
                  color="red"
                  class="mx-2"
                  :dark="hasFilters"
                  @click="cleanFilter()"
                >
                  Limpar filtros
                </v-btn>
                <v-btn
                  :loading="loading"
                  :disabled="!hasFilters"
                  :dark="hasFilters"
                  elevation="2"
                  color="green"
                  @click="filterSearch()"
                >
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-tabs class="px-5 py-4">
        <v-tab>Hierarquia</v-tab>
        <v-tab>Gerenciamento Rápido</v-tab>

        <v-tab-item>
          <div class="table p-relative">
            <table-title-row :columnsOptions="columnOptions"></table-title-row>
            <v-progress-linear v-if="isShipmentsLoading" indeterminate color="primary"></v-progress-linear>
            <template v-if="nodes.length">
              <template v-for="(node, nodeIndex) in nodes">
                <div :key="node.data.id">
                  <table-body-row
                    :node="node"
                    :nodeIndex="nodeIndex"
                    :columns="columns"
                    :lengthDataToTruncate="12"
                    :type="'Embarque'"
                    :enableCheckbox="true"
                    :enableDropdown="false"
                    @onExpand="onExpand(node)"
                    @changeCheckbox="changeSelectedCheckbox"
                    @openEdit="openEdit"
                    @openDelete="openDelete"
                  >
                  </table-body-row>

                  <Status :nodeIndex="nodeIndex" :status="node.data.boardingStatus" />

                  <v-row v-if="node.open" style="margin-top: 0">
                    <v-col cols="12">
                      <v-card :loading="loading" class="mx-1">
                        <v-card-text class="p-5">
                          <table-title-row :columnsOptions="columnsCargoOptions"></table-title-row>
                          <template v-for="(cargo, cargoIndex) in node.children">
                            <div :key="cargo.data.id">
                              <table-body-row
                                :node="cargo"
                                :nodeIndex="cargoIndex"
                                :columns="columnsCargo"
                                :lengthDataToTruncate="20"
                                :type="'Carga'"
                                :shipmentIndex="nodeIndex"
                                :enableCheckbox="true"
                                :enableDropdown="false"
                                @onExpand="onExpand(cargo)"
                                @changeCheckbox="changeSelectedCheckbox"
                              >
                              </table-body-row>

                              <Status :nodeIndex="cargoIndex" :status="cargo.data.cargoStatus" />

                              <v-row v-if="cargo.open" style="margin-top: 0">
                                <v-col cols="12">
                                  <v-card :loading="loading">
                                    <v-card-text class="p-5">
                                      <table-title-row :columnsOptions="columnsStopOptions"></table-title-row>

                                      <template v-for="(stop, stopIndex) in cargo.children">
                                        <div :key="stop.data.id">
                                          <table-body-row
                                            :node="stop"
                                            :nodeIndex="stopIndex"
                                            :columns="columnsStops"
                                            :lengthDataToTruncate="12"
                                            :type="'Parada'"
                                            :shipmentIndex="nodeIndex"
                                            :cargoIndex="cargoIndex"
                                            :enableCheckbox="true"
                                            :enableDropdown="false"
                                            @onExpand="onExpand(stop)"
                                            @changeCheckbox="changeSelectedCheckbox"
                                          >
                                          </table-body-row>

                                          <Status :nodeIndex="stopIndex" :status="stop.data.cargoStatus" />

                                          <v-row v-if="stop.open" style="margin-top: 0">
                                            <v-col cols="12">
                                              <v-card :loading="loading">
                                                <v-card-text class="p-5">
                                                  <table-title-row
                                                    :columnsOptions="columnsDeliveriesOptions"
                                                  ></table-title-row>

                                                  <template v-for="(deliveries, deliveriesIndex) in stop.children">
                                                    <div :key="deliveries.data.id">
                                                      <table-body-row
                                                        :node="deliveries"
                                                        :nodeIndex="deliveriesIndex"
                                                        :columns="columnsDeliveries"
                                                        :lengthDataToTruncate="9"
                                                        :type="'Entrega'"
                                                        :shipmentIndex="nodeIndex"
                                                        :cargoIndex="cargoIndex"
                                                        :stopIndex="stopIndex"
                                                        :enableCheckbox="true"
                                                        :enableDropdown="false"
                                                        @onExpand="onExpand(deliveries)"
                                                        @changeCheckbox="changeSelectedCheckbox"
                                                      >
                                                      </table-body-row>

                                                      <Status
                                                        :nodeIndex="deliveriesIndex"
                                                        :status="deliveries.data.deliveryStatus"
                                                      />

                                                      <v-row v-if="deliveries.open" style="margin-top: 0">
                                                        <v-col cols="12">
                                                          <v-card :loading="loading">
                                                            <v-card-text class="p-5">
                                                              <table-title-row
                                                                :columnsOptions="columnsNfeOptions"
                                                              ></table-title-row>

                                                              <template v-for="(nfe, nfeIndex) in deliveries.children">
                                                                <div :key="nfe.data.id">
                                                                  <table-body-row
                                                                    :node="nfe"
                                                                    :nodeIndex="nfeIndex"
                                                                    :columns="columnsNfe"
                                                                    :lengthDataToTruncate="16"
                                                                    :itemsDropdown="itemsDropdownNfe(nfe)"
                                                                    :type="'Nota Fiscal'"
                                                                    :shipmentIndex="nodeIndex"
                                                                    :cargoIndex="cargoIndex"
                                                                    :stopIndex="stopIndex"
                                                                    :deliveryIndex="deliveriesIndex"
                                                                    :enableCheckbox="true"
                                                                    :enableDropdown="true"
                                                                    @onExpand="onExpand(nfe)"
                                                                    @changeCheckbox="changeSelectedCheckbox"
                                                                    @actionsDropdown="actionsDropdownNfe"
                                                                  >
                                                                  </table-body-row>

                                                                  <Status
                                                                    :nodeIndex="nfeIndex"
                                                                    :status="nfe.data.nfeStatus"
                                                                  />
                                                                </div>
                                                              </template>
                                                            </v-card-text>
                                                          </v-card>
                                                          <div class="mt20"></div>
                                                        </v-col>
                                                      </v-row>
                                                    </div>
                                                  </template>
                                                </v-card-text>
                                              </v-card>
                                              <div class="mt20"></div>
                                            </v-col>
                                          </v-row>
                                        </div>
                                      </template>
                                    </v-card-text>
                                  </v-card>
                                  <div class="mt20"></div>
                                </v-col>
                              </v-row>
                            </div>
                          </template>
                        </v-card-text>
                      </v-card>
                      <div class="mt20"></div>
                    </v-col>
                  </v-row>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="d-flex justify-center pt-6 pb-2" style="color: grey">Nenhum embarque encontrado.</div>
            </template>
            <div class="d-flex justify-space-between align-center mt-7">
              <div class="d-flex">
                <v-pagination v-model="page" :length="paginate.totalPages" :total-visible="7"></v-pagination>
              </div>
              <div class="d-flex align-center justify-end flex-wrap" style="gap: 12px">
                <v-btn elevation="2" color="info" small @click="handleTransferShipment"> TRANSFERIR </v-btn>
                <v-btn elevation="2" color="info" small @click="openUpdateStatus()"> ATUALIZAR STATUS </v-btn>
                <v-btn elevation="2" color="info" small @click="openMultipleNfeSheet()"> IMPORTAR VOLUMES </v-btn>
                <v-btn elevation="2" color="info" small @click="shipmentReceiptsManagement()">
                  GERENCIAR CANHOTOS
                </v-btn>
                <items-per-page-selector @change="onPageSizeChange" class="pl-5"></items-per-page-selector>
              </div>
            </div>
          </div>
        </v-tab-item>

        <v-tab-item>
          <div class="table p-relative" style="width: 100%">
            <table-title-row :columnsOptions="columnOptions"></table-title-row>
            <v-progress-linear v-if="isShipmentsLoading" indeterminate color="primary"></v-progress-linear>
            <template v-if="nodesFast.length">
              <template v-for="(nodeFast, nodeFastIndex) in nodesFast">
                <div :key="`${nodeFast.data.id}-Fast`">
                  <table-body-row
                    :node="nodeFast"
                    :nodeIndex="nodeFastIndex"
                    :columns="columns"
                    :lengthDataToTruncate="12"
                    :type="'Embarque'"
                    :enableCheckbox="true"
                    :enableDropdown="false"
                    @onExpand="onFastExpand(nodeFast)"
                    @changeCheckbox="changeSelectedCheckbox"
                    @openEdit="openEdit"
                  >
                  </table-body-row>

                  <Status :nodeIndex="nodeFastIndex" :status="nodeFast.data.boardingStatus" />

                  <v-row v-if="nodeFast.open" style="margin-top: 0">
                    <v-col cols="12">
                      <v-card :loading="loading" class="mx-1">
                        <v-card-text class="p-5">
                          <table-title-row :columnsOptions="columnsNfeFastOptions" dense></table-title-row>

                          <template v-for="(nfeFast, nfeFastIndex) in nodeFast.children">
                            <div :key="nfeFast.data.id">
                              <table-body-row
                                :node="nfeFast"
                                :nodeIndex="nfeFastIndex"
                                :columns="columnsNfeFast"
                                :lengthDataToTruncate="11"
                                :itemsDropdown="itemsDropdownNfeFast(nfeFast)"
                                :type="'Nota Fiscal'"
                                :shipmentIndex="nodeFastIndex"
                                :enableCheckbox="true"
                                :enableDropdown="true"
                                dense
                                @changeCheckbox="changeSelectedCheckbox"
                                @actionsDropdown="actionsDropdownNfeFast"
                              >
                              </table-body-row>

                              <Status :nodeIndex="nfeFastIndex" :status="nfeFast.data.nfeStatus" />
                            </div>
                          </template>
                        </v-card-text>
                      </v-card>
                      <div class="mt20"></div>
                    </v-col>
                  </v-row>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="d-flex justify-center pt-6 pb-2" style="color: grey">Nenhum embarque encontrado.</div>
            </template>

            <div class="d-flex justify-space-between align-center mt-7">
              <div class="d-flex">
                <v-pagination v-model="page" :length="paginate.totalPages" :total-visible="7"></v-pagination>
              </div>

              <div class="d-flex align-center justify-end flex-wrap" style="gap: 12px">
                <v-btn elevation="2" color="info" small @click="transferShipment = true"> TRANSFERIR </v-btn>
                <v-btn elevation="2" color="info" small @click="openUpdateStatus()"> ATUALIZAR STATUS </v-btn>
                <v-btn elevation="2" color="info" small @click="openMultipleNfeSheet()"> IMPORTAR VOLUMES </v-btn>
                <v-btn elevation="2" color="info" small @click="shipmentReceiptsManagement()">
                  GERENCIAR CANHOTOS
                </v-btn>
                <items-per-page-selector @change="onPageSizeChange" class="pl-5"></items-per-page-selector>
              </div>
            </div>
          </div>
        </v-tab-item>
      </v-tabs>
    </v-card>
    <SheetPackages
      :open="validSheet"
      :nfeId="nfeSelectedId"
      :multiple="filesDialog"
      @closeSheetPackages="closeSheetPackages"
    />

    <NfeAttachments
      :open="anexos"
      :nfeId="nfeSelectedId"
      @closeNfeAttachments="closeNfeAttachments"
      @actionsMessage="nfeAttachmentsActionsMessage"
    />

    <NfeReceipt
      :open="canhoto"
      :nfeId="nfeSelectedId"
      @closeNfeReceipt="closeNfeReceipt"
      @canhotoApprove="canhotoApprove"
    />

    <EditShipment :open="editShipment" :shipment="dateShipmentEdit" @closeEditShipment="closeEditShipment" />

    <TranshipmentTransfer
      :open="transferShipment"
      @closeTranshipmentTransfer="closeShipmentTransfer"
      :selectedCheckbox="selectedCheckbox"
      shipmentTransfer
    />

    <UpdateStatusNfe
      :selectedCheckbox="selectedCheckbox"
      :nfeSelected="nfeSelected"
      :open="updateStatus"
      role="Boardings"
      @closeUpdateStatusNfe="closeUpdateStatusNfe"
    />

    <HistoricNfe :id="nfeSelectedId" :open="historic" @closeHistoricNfe="historic = false" />

    <NfeDetails :node="nfeSelected" :open="nfeDetails" @closeNfeDetails="nfeDetails = false" />

    <UpdateCompletionDate
      :shipmentNode="nfeSelected"
      :open="updateCompletionDate"
      @closeModal="closeUpdateCompletionDate"
    />

    <ExportReportDialog
      :isOpen.sync="isExportReportOpen"
      :filters="filters"
      :states="states"
      :cities="cities"
      :transhipments="transhipments"
      :status="statusList"
      :couriers="couriers"
      :senders="senders"
      @errorOnExport="onExportError"
    />

    <delete-confirm-dialog
      :isOpen.sync="isDeleteConfirmOpen"
      @confirmClick="handleDeleteShipment"
      :isConfirmBtnLoading="isDeleteButtonLoading"
      title="Deletar embarque"
      body-text="Você confirma deletar este embarque?"
    />

    <MessagesError :type="errorsType" :errors="errors" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';

import BreadCrumb from '../../../components/BreadCrumb.vue';
import MessagesError from '../../../components/MessagesError.vue';

import Base64Mixin from '../../../mixins/base64.mixin';

import copyToClipboard from '../../../utils/copyToClipboard';
import maskCPF from '../../../utils/maskCPF';
import maskCNPJ from '../../../utils/maskCNPJ';
import maskData from '../../../utils/maskData';
import maskPrice from '../../../utils/maskPrice';
import maskWeight from '../../../utils/maskWeight';
import changeCheckbox from '../../../utils/changeSelectedCheckbox';

import EditShipment from '../../../components/Shipment/EditShipment.vue';
import SheetPackages from '../../../components/Shipment/SheetPackages.vue';
import TranshipmentTransfer from '../../../components/TransferHierarchy.vue';
import UpdateStatusNfe from '../../../components/Nfe/UpdateStatusNfe.vue';
import NfeReceipt from '../../../components/Nfe/NfeReceipt.vue';
import HistoricNfe from '../../../components/Nfe/HistoricNfe.vue';
import NfeAttachments from '../../../components/Nfe/NfeAttachments.vue';
import NfeDetails from '../../../components/Nfe/NfeDetails.vue';
import UpdateCompletionDate from '../../../components/Nfe/UpdateCompletionDate.vue';

import TableTitleRow from '../../../components/Table/Table-Title-Row.vue';
import TableBodyRow from '../../../components/Table/Table-Body-Row.vue';
import Status from '../../../components/Table/Status.vue';
import DeleteConfirmDialog from '@/components/ConfirmDialog';
import ExportReportDialog from '@/components/Shipment/ExportReportDialog';
import ItemsPerPageSelector from '@/components/ItemsPerPageSelector.vue';
import comboboxFormatter from '@/utils/comboboxFormatter';
import allowedChars from '@/utils/allowedChars';
export default {
  name: 'Shipments',
  components: {
    BreadCrumb,
    MessagesError,
    UpdateStatusNfe,
    HistoricNfe,
    TableTitleRow,
    TableBodyRow,
    Status,
    EditShipment,
    TranshipmentTransfer,
    NfeReceipt,
    NfeAttachments,
    SheetPackages,
    NfeDetails,
    UpdateCompletionDate,
    DeleteConfirmDialog,
    ExportReportDialog,
    ItemsPerPageSelector
  },

  props: {
    boardingIdFilter: {
      default: '',
      type: String
    }
  },

  mixins: [Base64Mixin],
  data: () => ({
    senderId: '',
    senders: [],
    transhipments: [],
    isShipmentsLoading: false,
    states: [],
    cities: [],
    statusList: [],
    filters: null,
    isDeleteConfirmOpen: false,
    isDeleteButtonLoading: false,
    shipmentIdToDelete: '',
    boardingNumberInput: '',
    cteNumberInput: '',
    keyNfeInput: '',
    isTransferred: null,
    boardingId: null,
    numberInvoiceId: null,
    numberCTE: [],
    sender: null,
    recipient: null,
    keyNfe: [],
    freightPriceTransfer: null,
    totalMileageTransfer: null,
    boardingNumber: [],
    courierId: null,
    justification: null,
    transferShipment: false,
    nfeAttachments: [],
    nfeCanhotos: [],
    viewCheckbox: false,
    dateShipmentEdit: null,
    isFather: [],
    anexos: false,
    canhoto: false,
    historic: false,
    updateStatus: false,
    isExportReportOpen: false,
    images: [],
    imagesUpload: [],
    imagesCanhoto: [],
    imagesCanhotoUpload: [],
    editShipment: false,
    errors: [],
    errorsType: 'error',
    selectedCheckbox: [],
    filesDialog: false,
    validSheet: false,
    file: null,
    fileNfe: null,
    nfeSelected: [],
    nfeSelectedId: null,
    transhipmentId: null,
    cityId: null,
    stateId: null,
    loadingCity: false,
    initialAuthDate: null,
    menu: false,
    activePicker: null,
    endAuthDate: null,
    menu1: false,
    activePicker1: null,
    date2: null,
    menu2: false,
    activePicker2: null,
    date3: null,
    menu3: false,
    activePicker3: null,
    itemProcessing: [],
    loadingShipment: false,
    freightPrice: '',
    totalMileage: '',
    status: [],
    nfeDetails: false,
    updateCompletionDate: false,
    isCouriersLoading: false,
    couriers: [],
    courierName: '',
    isCouriersLastPage: false,
    columns: ['type', 'createdAt', 'driverName', 'shipmentfinancialData', 'totalMileage', 'progress', 'actions'],
    columnOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'createdAt',
        text: 'Data de Criação'
      },
      {
        value: 'driverName',
        text: 'Nome do Motorista'
      },
      {
        value: 'shipmentfinancialData',
        text: 'Preço do Frete'
      },
      {
        value: 'totalMileage',
        text: 'Total de KM'
      },
      {
        value: 'progress',
        text: 'Conclusão'
      },
      {
        value: 'actions',
        text: 'Ações'
      }
    ],
    columnsCargo: ['type', 'boardingNumber', 'transhipmentName', 'financialData', 'transferred', 'progress', 'actions'],
    columnsCargoOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'boardingNumber',
        text: 'N° Embarque Externo'
      },
      {
        value: 'transhipmentName',
        text: 'Transbordo'
      },
      {
        value: 'financialData',
        text: 'Financeiro'
      },
      {
        value: 'transferred',
        text: 'Transferência'
      },
      {
        value: 'progress',
        text: 'Conclusão'
      },
      {
        value: 'actions',
        text: 'Ações'
      }
    ],
    columnsStops: [
      'type',
      'cityName',
      'recipientCpfOrCnpj',
      'recipientName',
      'transhipmentPrice',
      'progress',
      'actions'
    ],
    columnsStopOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'cityName',
        text: 'Cidade'
      },
      {
        value: 'recipientCpfOrCnpj',
        text: 'CPF/CNPJ do Destinatário'
      },
      {
        value: 'recipientName',
        text: 'Nome do Destinatário'
      },
      {
        value: 'transhipmentPrice',
        text: 'Preço do Transbordo'
      },
      {
        value: 'progress',
        text: 'Conclusão'
      },
      {
        value: 'actions',
        text: 'Ações'
      }
    ],
    columnsDeliveries: [
      'type',
      'numberCte',
      'authorizationDate',
      'costFreight',
      'deliveryForecast',
      'emissionDate',
      'senderName',
      'actions'
    ],
    columnsDeliveriesOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'numberCte',
        text: 'Número CTE'
      },
      {
        value: 'authorizationDate',
        text: 'Data de Autorização'
      },
      {
        value: 'costFreight',
        text: 'Custo do Frete'
      },
      {
        value: 'deliveryForecast',
        text: 'Previsão de Entrega'
      },
      {
        value: 'emissionDate',
        text: 'Data de Emissão'
      },
      {
        value: 'senderName',
        text: 'Enviado por'
      },
      {
        value: 'actions',
        text: 'Ações'
      }
    ],
    columnsNfe: ['type', 'number', 'price', 'weight', 'completionDate', 'receiptStatus', 'actions'],
    columnsNfeOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      { value: 'number', text: 'Número NFE' },
      { value: 'price', text: 'Preço da NF' },
      { value: 'weight', text: 'Peso da NF' },
      { value: 'completionDate', text: 'Data de Conclusão' },
      {
        value: 'receiptStatus',
        text: 'Backup do canhoto'
      },
      { value: 'actions', text: 'Ações' }
    ],
    columnsNfeFast: [
      'type',
      'number',
      'numberCte',
      'transhipmentName',
      'recipientName',
      'cityName',
      'senderName',
      'authorizationDate',
      'deliveryForecast',
      'completionDate',
      'receiptStatus',
      'actions'
    ],
    columnsNfeFastOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      { value: 'number', text: 'Número NFE' },
      { value: 'numberCte', text: 'Número CTE' },
      { value: 'transhipmentName', text: 'Transbordo' },
      { value: 'recipientName', text: 'Destinatário' },
      { value: 'cityName', text: 'Cidade' },
      { value: 'senderName', text: 'Remetente' },
      { value: 'authorizationDate', text: 'Data de Autorização' },
      { value: 'deliveryForecast', text: 'Previsão de Entrega' },
      { value: 'completionDate', text: 'Data de Conclusão' },
      {
        value: 'receiptStatus',
        text: 'Backup do canhoto'
      },
      { value: 'actions', text: 'Ações' }
    ],
    expandedKeys: {},
    nodes: [],
    nodesFast: [],
    loadingCreate: false,
    loading: true,
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Embarques',
        disabled: false,
        to: '/shipments'
      }
    ],
    hasReceiptFilter: null,
    isTransferredOptions: [
      { text: 'Sim', value: true },
      { text: 'Não', value: false }
    ],
    hasReceiptOptions: [
      { text: 'Sim', value: true },
      { text: 'Não', value: false }
    ],
    isReceiptValidFilter: null,
    isReceiptValidOptions: [
      { text: 'Sim', value: true },
      { text: 'Não', value: false }
    ],
    booleanOptions: [
      { text: 'Sim', value: true },
      { text: 'Não', value: false }
    ],
    isReceiptDownloaded: null,
    isReceiptPurged: null,
    headers: [
      {
        text: 'Chave da Nota',
        align: 'start',
        value: 'key'
      },
      {
        text: 'ID do Volume',
        value: 'id'
      },
      { text: 'Peso', value: 'weight' }
    ],
    error500: null
  }),
  computed: {
    ...mapGetters('NfeStore', ['getStatus']),
    ...mapGetters('TranshipmentStore', ['getTranshipments']),
    ...mapState('ShipmentStore', ['paginate']),
    ...mapGetters('ShipmentStore', ['getManegementShipments']),
    ...mapGetters('CouriersStore', ['getSummaryData']),
    ...mapGetters('UserStore', ['getUsers']),
    ...mapGetters('CouriersStore', ['getCouriers']),
    page: {
      get() {
        return this.paginate.pageNumber;
      },
      set(value) {
        this.setPageNumber(value);

        this.fetchAllShipment();
      }
    },
    getColumns() {
      const newColumns = this.columns.map((item) => {
        const newItem = this.columnOptions.filter((option) => {
          return option.value === item;
        });

        return newItem[0];
      });
      return newColumns;
    },
    hasFilters() {
      if (
        this.initialAuthDate ||
        this.endAuthDate ||
        this.stateId ||
        this.cityId ||
        this.hasReceiptFilter !== null ||
        this.isReceiptValidFilter !== null ||
        this.isTransferred !== null ||
        this.isReceiptDownloaded !== null ||
        this.isReceiptPurged !== null ||
        this.transhipmentId ||
        this.senderId ||
        this.numberCTE.length !== 0 ||
        this.sender ||
        this.recipient ||
        this.keyNfe.length !== 0 ||
        this.boardingNumber.length !== 0 ||
        this.courierId ||
        this.boardingId ||
        this.numberInvoiceId ||
        this.status.length !== 0
      ) {
        return true;
      }
      return false;
    },
    formattedStartAuthDate() {
      if (!this.initialAuthDate) return '';
      const [year, month, day] = this.initialAuthDate.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedEndAuthDate() {
      if (!this.endAuthDate) return '';
      const [year, month, day] = this.endAuthDate.split('-');
      return `${day}/${month}/${year}`;
    }
  },

  async created() {
    this.getAllSenders();
    this.getStates();
    this.fetchAllStatus();
    this.setTranshipmentsItemPerPage(1000);
    await this.fetchSummaryDataTranshipment();
    this.setItemPerPage(10);
    const couriers = await this.fetchSummaryData();
    this.couriers = couriers;
    await this.cleanFilter(false);
    if (this.boardingIdFilter) {
      await this.setBoardingIdFilter();
    } else {
      await this.fetchAllShipment();
    }
  },
  async mounted() {
    await this.fetchAllSummaryData();
  },
  methods: {
    ...mapActions('AccountsStore', ['getSenders']),
    ...mapActions('AdressStore', ['fetchStates', 'fetchCities']),
    ...mapActions('UserStore', ['fetchUsers']),
    ...mapActions('TranshipmentStore', ['getSummaryDataTranshipment']),
    ...mapActions('ShipmentStore', [
      'fetchManegementShipments',
      'fetchManegementShipmentsCargoByID',
      'fetchManegementShipmentsStopsByID',
      'fetchManegementShipmentsDeliveriesByID',
      'fetchManegementShipmentsNFEByID',
      'fetchFastManegementShipmentsNFEByID',
      'deleteShipment',
      'createShipment',
      'fetchShipmentByID',
      'fetchStatusShipment',
      'createSheetPackages',
      'createSheetPackagesNfe',
      'fetchEditShipment',
      'sendtransferHierarchy',
      'deleteShipment'
    ]),
    ...mapActions('CouriersStore', ['fetchSummaryData']),
    ...mapActions('NfeStore', [
      'createNfeAttachments',
      'fetchNfeAttachmentsById',
      'createReceiptNfe',
      'fetchReceiptNfeById',
      'fetchDownloadNfeAttachmentsById',
      'deleteNfeAttachmentById',
      'getSrcImage',
      'appovreNfeReceipt',
      'fetchStatus'
    ]),
    ...mapMutations('NfeStore', ['setSelectedCheckbox']),
    ...mapMutations('TranshipmentStore', { setTranshipmentsItemPerPage: 'setItemPerPage' }),
    ...mapMutations('ShipmentStore', [
      'setItemPerPage',
      'setPageNumber',
      'setFiltersManegementAuthorizationDateStart',
      'setFiltersManegementAuthorizationDateEnd',
      'setFiltersManegementStateId',
      'setFiltersManegementCityId',
      'setFiltersManegementHasReceipt',
      'setFiltersManegementIsReceiptValid',
      'setFiltersManegementTranshipmentId',
      'setFiltersManegementIsTransferred',
      'setFiltersManegementDownloadedReceipt',
      'setFiltersManegementPurgedReceipt',
      'setFiltersManegementCteNumber',
      'setFiltersManegementSenderName',
      'setFiltersManegementSenderId',
      'setFiltersManegementRecipientName',
      'setFiltersManegementNfeNumber',
      'setFiltersManegementBoardingNumber',
      'setFiltersManegementDirectDelivererId',
      'setFiltersManegementBoardingId',
      'setFiltersManegementNumberInvoiceId',
      'setFiltersManegementStatus'
    ]),
    getFilters() {
      const {
        isReceiptDownloaded,
        isReceiptPurged,
        initialAuthDate,
        endAuthDate,
        stateId,
        cityId,
        hasReceiptFilter,
        isReceiptValidFilter,
        isTransferred,
        transhipmentId,
        numberCTE,
        senderId,
        recipient,
        keyNfe,
        boardingNumber,
        courierId,
        boardingId,
        numberInvoiceId,
        status
      } = this;

      return {
        isReceiptDownloaded,
        isReceiptPurged,
        initialAuthDate,
        endAuthDate,
        stateId,
        cityId,
        hasReceiptFilter,
        isReceiptValidFilter,
        isTransferred,
        transhipmentId,
        numberCTE,
        senderId,
        recipient,
        keyNfe,
        boardingNumber,
        courierId,
        boardingId,
        numberInvoiceId,
        status
      };
    },
    onPageSizeChange(value) {
      this.setPageNumber(1);
      this.setItemPerPage(value);
      this.fetchAllShipment();
    },
    handleTransferShipment() {
      if (this.selectedCheckbox.length === 0) {
        this.errors = ['Nenhum item selecionado.'];
        this.errorsType = 'info';
      } else {
        this.transferShipment = true;
      }
    },
    shipmentReceiptsManagement() {
      if (this.selectedCheckbox.length === 0) {
        this.errors = ['Nenhum item selecionado.'];
        this.errorsType = 'info';
      } else {
        this.setSelectedCheckbox(this.selectedCheckbox);
        this.$router.push('/shipments/receipts');
      }
    },
    async closeUpdateStatusNfe(hasChange, message) {
      this.updateStatus = false;
      this.nfeSelected = [];
      if (hasChange) await this.fetchAllShipment();
      if (message) {
        this.errors = message.errors;
        this.errorsType = message.errorsType;
        this.error500 = message.error500;
      }
    },
    closeUpdateCompletionDate(hasChange, message) {
      this.updateCompletionDate = false;
      this.nfeSelected = [];
      if (hasChange) this.cleanFilter();
      if (message) {
        this.errors = message.errors;
        this.errorsType = message.errorsType;
        this.error500 = message.error500;
      }
    },
    openUpdateStatus() {
      this.nfeSelected = [];

      if (this.selectedCheckbox.length === 0) {
        this.errors = ['Nenhum item selecionado.'];
        this.errorsType = 'info';
      } else {
        this.updateStatus = true;
      }
    },

    copy(str) {
      copyToClipboard(str);
    },
    actionsDropdownNfe(index, node) {
      this.nfeSelectedId = node.data.id;
      this.nfeSelected.push(node.data);
      if (index === 0) {
        this.updateStatus = true;
      } else if (index === 1) {
        this.anexos = true;
      } else if (index === 2) {
        this.canhoto = true;
      } else if (index === 3) {
        this.historic = true;
      } else if (index === 4) {
        this.validSheet = true;
      } else {
        this.updateCompletionDate = true;
      }
    },
    actionsDropdownNfeFast(index, node) {
      this.nfeSelectedId = node.data.id;
      this.nfeSelected = [];
      this.nfeSelected.push(node.data);
      if (index === 0) {
        this.updateStatus = true;
      } else if (index === 1) {
        this.anexos = true;
      } else if (index === 2) {
        this.canhoto = true;
      } else if (index === 3) {
        this.historic = true;
      } else if (index === 4) {
        this.validSheet = true;
      } else if (index === 5) {
        this.nfeDetails = true;
      } else {
        this.updateCompletionDate = true;
      }
    },
    openEdit(shipment) {
      this.editShipment = true;
      this.dateShipmentEdit = shipment;
    },

    async setBoardingIdFilter() {
      this.boardingId = this.boardingIdFilter;
      await this.saveBoardingId();
    },

    async cleanFilter(shouldRefresh = true) {
      this.setFiltersManegementAuthorizationDateStart(null);
      this.setFiltersManegementAuthorizationDateEnd(null);
      this.setFiltersManegementStateId(null);
      this.setFiltersManegementCityId(null);
      this.setFiltersManegementHasReceipt(null);
      this.setFiltersManegementIsReceiptValid(null);
      this.setFiltersManegementTranshipmentId(null);
      this.setFiltersManegementIsTransferred(null);
      this.setFiltersManegementDownloadedReceipt(null);
      this.setFiltersManegementPurgedReceipt(null);
      this.setFiltersManegementCteNumber([]);
      this.setFiltersManegementSenderId(null);
      this.setFiltersManegementRecipientName(null);
      this.setFiltersManegementNfeNumber([]);
      this.setFiltersManegementBoardingNumber([]);
      this.setFiltersManegementBoardingId(null);
      this.setFiltersManegementNumberInvoiceId(null);
      this.setFiltersManegementDirectDelivererId(null);
      this.setFiltersManegementStatus([]);
      if (shouldRefresh) {
        await this.fetchAllShipment();
        await this.fetchAllShipmentFast();
      }

      this.clearFilterFields();
    },
    clearFilterFields() {
      this.isReceiptDownloaded = null;
      this.isReceiptPurged = null;
      this.initialAuthDate = null;
      this.endAuthDate = null;
      this.stateId = null;
      this.cityId = null;
      this.hasReceiptFilter = null;
      this.isTransferred = null;
      this.isReceiptValidFilter = null;
      this.transhipmentId = null;
      this.numberCTE = [];
      this.senderId = null;
      this.recipient = null;
      this.keyNfe = [];
      this.courierId = null;
      this.boardingNumber = [];
      this.boardingId = null;
      this.numberInvoiceId = null;
      this.status = [];
    },
    filterSearch() {
      this.setPageNumber(1);
      this.fetchAllShipment();
    },
    filterInput(event) {
      return allowedChars(event, /[0-9,.;/]/);
    },
    changeSelectedCheckbox(item, children, shipmentIndex, cargoIndex, stopIndex, deliveriesIndex) {
      this.selectedCheckbox = changeCheckbox(
        this.selectedCheckbox,
        item,
        children,
        cargoIndex,
        stopIndex,
        deliveriesIndex,
        this.nodes[shipmentIndex]
      );
    },
    transformWeight(weight) {
      return maskWeight(weight);
    },
    transformPrice(price) {
      return maskPrice(price);
    },
    transformCpfOrCnpj(str) {
      if (str.length === 11) {
        return maskCPF(str);
      }

      return maskCNPJ(str);
    },
    transformDate(date) {
      return maskData(date);
    },

    async fetchAllStates() {
      try {
        await this.fetchStates();
      } catch (err) {
        console.error(err);
      }
    },
    async fetchAllStatus() {
      try {
        this.statusList = await this.fetchStatus();
      } catch (err) {
        console.error(err);
      }
    },
    async fetchSummaryDataTranshipment() {
      try {
        this.transhipments = await this.getSummaryDataTranshipment();
      } catch (err) {
        console.error(err);
      }
    },

    saveStateId(event) {
      this.setFiltersManegementStateId(event);
    },
    saveCityId() {
      this.setFiltersManegementCityId(this.cityId);
    },
    saveHasReceipt() {
      this.setFiltersManegementHasReceipt(this.hasReceiptFilter);
    },
    saveIsReceiptValid() {
      this.setFiltersManegementIsReceiptValid(this.isReceiptValidFilter);
    },
    saveIsReceiptDownloaded() {
      this.setFiltersManegementDownloadedReceipt(this.isReceiptDownloaded);
    },
    saveIsReceiptPurged() {
      this.setFiltersManegementPurgedReceipt(this.isReceiptPurged);
    },
    saveTranshipmentId() {
      this.setFiltersManegementTranshipmentId(this.transhipmentId);
    },
    saveIsTransferred() {
      this.setFiltersManegementIsTransferred(this.isTransferred);
    },
    saveCteNumber(value) {
      this.numberCTE = comboboxFormatter(value);
      this.setFiltersManegementCteNumber(this.numberCTE);
    },
    saveSenderId() {
      this.setFiltersManegementSenderId(this.senderId);
    },
    saveSenderName() {
      this.setFiltersManegementSenderName(this.sender);
    },
    saveRecipientName() {
      this.setFiltersManegementRecipientName(this.recipient);
    },
    saveNfeNumber(value) {
      this.keyNfe = comboboxFormatter(value);
      this.setFiltersManegementNfeNumber(this.keyNfe);
    },
    saveBoardingNumber(value) {
      this.boardingNumber = comboboxFormatter(value);
      this.setFiltersManegementBoardingNumber(this.boardingNumber);
    },
    saveBoardingId() {
      this.setFiltersManegementBoardingId(this.boardingId);
    },
    saveNumberInvoiceId() {
      this.setFiltersManegementNumberInvoiceId(this.numberInvoiceId);
    },
    saveCourierId() {
      this.setFiltersManegementDirectDelivererId(this.courierId);
    },
    saveStatus() {
      this.setFiltersManegementStatus(this.status);
    },
    closeAndOpen() {
      this.filesDialog = false;
      this.validSheet = true;
    },
    save(date) {
      this.$refs.menu.save(date);

      const partOfDate = date.split('-');
      const newDate = new Date(partOfDate[0], partOfDate[1] - 1, partOfDate[2]);

      this.setFiltersManegementAuthorizationDateStart(newDate.toISOString());
    },
    save1(date) {
      this.$refs.menu1.save(date);

      const partOfDate = date.split('-');
      const newDate = new Date(partOfDate[0], partOfDate[1] - 1, partOfDate[2]);

      this.setFiltersManegementAuthorizationDateEnd(newDate.toISOString());
    },
    onChange(file) {
      this.file = file || null;
    },
    async fetchAllSummaryData() {
      this.isLoading = true;
      try {
        await this.fetchSummaryData();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async fetchAllShipment() {
      this.isShipmentsLoading = true;
      try {
        await this.fetchManegementShipments();

        const newShipments = this.getManegementShipments.map((item, index) => {
          return {
            key: index,
            data: {
              ...item,
              createdAt: this.transformDate(item.createdAt),
              totalMileage: this.transformWeight(item.totalMileage),
              type: 'Embarque',
              actions: ''
            },
            children: [],
            type: 'Shipments',
            open: false,
            selected: false
          };
        });

        this.nodes = newShipments;
      } catch (err) {
        console.error(err);
      } finally {
        this.isShipmentsLoading = false;
        this.fetchAllShipmentFast();
        setTimeout(() => {
          this.viewCheckbox = true;
          this.selectedCheckbox = [];
        }, 0);
      }
    },
    fetchAllShipmentFast() {
      this.isShipmentsLoading = true;
      const newFastShipments = this.getManegementShipments.map((item, index) => {
        return {
          key: index,
          data: {
            ...item,
            createdAt: this.transformDate(item.createdAt),
            totalMileage: this.transformWeight(item.totalMileage),
            type: 'Embarque',
            actions: ''
          },
          children: [],
          type: 'Shipments',
          open: false,
          selected: false
        };
      });
      this.nodesFast = newFastShipments;
      this.isShipmentsLoading = false;
    },
    async onExpand(selected) {
      console.log(selected);
      this.loading = true;
      if (selected.type === 'Deliveries') {
        const idShipment = Number(selected.key.split('-')[0]);
        const idCargo = Number(selected.key.split('-')[1]);
        const idStop = Number(selected.key.split('-')[2]);
        const idDelivieres = Number(selected.key.split('-')[3]);

        this.nodes[idShipment].children[idCargo].children[idStop].children[idDelivieres].open =
          !this.nodes[idShipment].children[idCargo].children[idStop].children[idDelivieres].open;

        const { boardingId } = selected.data;
        try {
          const nfes = await this.fetchManegementShipmentsNFEByID(selected.data.id);

          const Nfes = nfes.map((item, index) => {
            return {
              key: selected.key + '-' + index,
              data: {
                ...item,
                type: 'Nota Fiscal',
                actions: '',
                completionDate: this.transformDate(item.completionDate),
                boardingId
              },
              type: 'Nfes',
              open: false,
              selected: false
            };
          });

          this.nodes[idShipment].children[idCargo].children[idStop].children[idDelivieres].children = Nfes;

          if (selected.selected) {
            const selectedIds = this.selectedCheckbox.map((item) => item.id);
            this.nodes[idShipment].children[idCargo].children[idStop].children[idDelivieres].children.map((nfe) => {
              nfe.selected = true;
              if (!selectedIds.includes(nfe.data.id)) {
                this.selectedCheckbox.push(nfe.data);
              }
            });
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.loading = false;
          this.changeCheckboxOnFetch();
        }
      }
      if (selected.type === 'Stops') {
        const idShipment = Number(selected.key.split('-')[0]);
        const idCargo = Number(selected.key.split('-')[1]);
        const idStop = Number(selected.key.split('-')[2]);

        this.nodes[idShipment].children[idCargo].children[idStop].open =
          !this.nodes[idShipment].children[idCargo].children[idStop].open;

        const { boardingId } = selected.data;
        try {
          const stops = await this.fetchManegementShipmentsDeliveriesByID(selected.data.id);

          const newDeliveries = stops.map((item, index) => {
            return {
              key: selected.key + '-' + index,
              data: {
                ...item,
                authorizationDate: this.transformDate(item.authorizationDate),
                deliveryForecast: this.transformDate(item.deliveryForecast),
                emissionDate: this.transformDate(item.emissionDate),
                boardingId,
                type: 'Entrega'
              },
              children: [],
              type: 'Deliveries',
              open: false,
              selected: false
            };
          });

          if (this.nodes[idShipment].children[idCargo].children[idStop].children.length === 0) {
            this.nodes[idShipment].children[idCargo].children[idStop].children = newDeliveries;
          }

          if (selected.selected) {
            const selectedIds = this.selectedCheckbox.map((item) => item.id);
            this.nodes[idShipment].children[idCargo].children[idStop].children.map((delivery) => {
              delivery.selected = true;
              if (!selectedIds.includes(delivery.data.id)) {
                this.selectedCheckbox.push(delivery.data);
              }
            });
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.loading = false;
          this.changeCheckboxOnFetch();
        }
      }
      if (selected.type === 'Cargo') {
        const idShipment = Number(selected.key.split('-')[0]);
        const idCargo = Number(selected.key.split('-')[1]);

        this.nodes[idShipment].children[idCargo].open = !this.nodes[idShipment].children[idCargo].open;

        const { boardingId } = selected.data;
        try {
          const stops = await this.fetchManegementShipmentsStopsByID(selected.data.id);

          const newStops = stops.map((item, index) => {
            return {
              key: selected.key + '-' + index,
              data: {
                ...item,
                recipientCpfOrCnpj: this.transformCpfOrCnpj(item.recipientCpfOrCnpj),
                transhipmentPrice: this.transformPrice(item.transhipmentPrice),
                boardingId,
                type: 'Parada'
              },
              children: [],
              type: 'Stops',
              open: false,
              selected: false
            };
          });
          if (this.nodes[idShipment].children[idCargo].children.length === 0) {
            this.nodes[idShipment].children[idCargo].children = newStops;
          }

          if (selected.selected) {
            const selectedIds = this.selectedCheckbox.map((item) => item.id);
            this.nodes[idShipment].children[idCargo].children.map((stop) => {
              stop.selected = true;
              if (!selectedIds.includes(stop.data.id)) {
                this.selectedCheckbox.push(stop.data);
              }
            });
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.loading = false;
          this.changeCheckboxOnFetch();
        }
      }
      if (selected.type === 'Shipments') {
        const { id: boardingId } = selected.data;
        this.nodes[selected.key].open = !this.nodes[selected.key].open;
        try {
          const data = await this.fetchManegementShipmentsCargoByID(selected.data.id);
          const newCargos = data.map((item, index) => {
            return {
              key: selected.key + '-' + index,
              data: {
                ...item,
                boardingId,
                type: 'Carga'
              },
              children: [],
              type: 'Cargo',
              open: false,
              selected: false
            };
          });
          if (this.nodes[selected.key].children.length === 0) {
            this.nodes[selected.key].children = newCargos;
          }

          if (selected.selected) {
            const selectedIds = this.selectedCheckbox.map((item) => item.id);
            this.nodes[selected.key].children.map((cargo) => {
              cargo.selected = true;
              if (!selectedIds.includes(cargo.data.id)) {
                this.selectedCheckbox.push(cargo.data);
              }
            });
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.loading = false;
          this.changeCheckboxOnFetch();
        }
      }
    },
    async onFastExpand(selected) {
      this.loading = true;
      if (selected.type === 'Shipments') {
        this.nodesFast[selected.key].open = !this.nodesFast[selected.key].open;
        try {
          const data = await this.fetchFastManegementShipmentsNFEByID(selected.data.id);
          const newCargos = data.map((item, index) => {
            return {
              key: selected.key + '-' + index,
              data: {
                ...item,
                authorizationDate: this.transformDate(item.authorizationDate),
                completionDate: this.transformDate(item.completionDate),
                deliveryForecast: this.transformDate(item.deliveryForecast),
                type: 'Nota Fiscal'
              },
              children: [],
              type: 'Nfe',
              open: false,
              selected: false
            };
          });
          if (this.nodesFast[selected.key].children.length === 0) {
            this.nodesFast[selected.key].children = newCargos;
          }

          if (selected.selected) {
            const selectedIds = this.selectedCheckbox.map((item) => item.id);
            this.nodesFast[selected.key].children.map((cargo) => {
              cargo.selected = true;
              if (!selectedIds.includes(cargo.data.id)) {
                this.selectedCheckbox.push(cargo.data);
              }
            });
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.loading = false;
          this.changeCheckboxOnFetch();
        }
      }
    },
    async handleDeleteShipment() {
      try {
        this.isDeleteButtonLoading = true;
        const response = await this.deleteShipment(this.shipmentIdToDelete);

        if (response.success) {
          this.errors = ['Embarque deletado com sucesso!'];
          this.errorsType = 'success';
          this.fetchAllShipment();
        } else {
          this.errors = response.errors;
          this.errorsType = 'error';
        }
        this.isDeleteConfirmOpen = false;
        console.log(this.shipmentIdToDelete);
      } catch (error) {
        console.error(error);
      } finally {
        this.isDeleteButtonLoading = false;
      }
    },
    openDelete(node) {
      this.shipmentIdToDelete = node.id;
      this.isDeleteConfirmOpen = true;
    },
    changeCheckboxOnFetch() {
      setTimeout(() => {
        const newCheckbox = this.selectedCheckbox;
        this.selectedCheckbox = newCheckbox;
      }, 0);
    },
    openDialogTrash(item, index) {
      this.dialogTrash = true;
      this.trashItem = {
        ...item,
        index
      };
    },
    openDialogStatus(item, index) {
      this.dialogStatus = true;
      this.statusItem = {
        ...item,
        index
      };
    },
    openMultipleNfeSheet() {
      this.filesDialog = true;
      this.validSheet = true;
    },
    onExportError({ errorsType, errors }) {
      this.errors = errors;
      this.errorsType = errorsType;
    },
    openExportReportDialog() {
      let filters = this.getFilters();
      this.filters = filters;

      this.isExportReportOpen = true;
    },
    async getAllSenders() {
      try {
        this.senders = await this.getSenders();
      } catch (error) {
        console.error(error);
      }
    },
    async getStates() {
      try {
        this.states = await this.fetchStates();
      } catch (error) {
        console.error(error);
      }
    },

    async fetchCitiesByID() {
      this.loadingCity = true;
      this.saveStateId(this.stateId);
      try {
        this.cities = await this.fetchCities(this.stateId);
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingCity = false;
      }
    },

    closeEditShipment(hasChange, message) {
      if (hasChange) {
        this.editShipment = false;
        this.errors = message.errors;
        this.errorsType = message.errorsType;
        this.error500 = message.error500;
        this.fetchAllShipment();
        this.fetchAllShipmentFast();
      } else {
        this.editShipment = false;
      }
    },
    closeShipmentTransfer(hasChange, message) {
      if (hasChange) {
        this.transferShipment = false;
        this.errors = message.errors;
        this.errorsType = message.errorsType;
        this.error500 = message.error500;
        this.fetchAllShipment();
        this.fetchAllShipmentFast();
      } else {
        this.transferShipment = false;
      }
    },
    closeNfeReceipt(hasChange, message) {
      if (hasChange) {
        this.canhoto = false;
        this.errors = message.errors;
        this.errorsType = message.errorsType;
        this.error500 = message.error500;
      } else {
        this.canhoto = false;
      }
    },
    closeNfeAttachments(hasChange, message) {
      if (hasChange) {
        this.anexos = false;
        this.errors = message.errors;
        this.errorsType = message.errorsType;
        this.error500 = message.error500;
      } else {
        this.anexos = false;
      }
    },
    closeSheetPackages(hasChange, message) {
      if (hasChange) {
        this.errors = message.errors;
        this.errorsType = message.errorsType;
        this.error500 = message.error500;
      }
      this.validSheet = false;
      this.filesDialog = false;
    },
    nfeAttachmentsActionsMessage(message) {
      this.errors = message.errors;
      this.errorsType = message.errorsType;
      this.error500 = message.error500;
    },
    canhotoApprove(message) {
      this.errors = message.errors;
      this.errorsType = message.errorsType;
      this.error500 = message.error500;
    },
    changeItemsPerPage(items) {
      this.setItemPerPage(items);

      this.fetchAllShipment();
    },
    openProcessing(item) {
      this.itemImportStatusProcessing = item.status === 'Processando';
      this.itemImportStatusError = item.status === 'Erro no processamento';
      this.isProcessing = true;

      this.fetchShipmentID(item.id);
    },
    async fetchShipmentID(id) {
      this.loadingShipment = true;

      try {
        const dados = await this.fetchShipmentByID(id);

        this.itemProcessing = dados;
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingShipment = false;
      }
    },
    itemsDropdownNfe(item) {
      const dataPaid = [
        { title: 'Atualizar Status' },
        { title: 'Anexos' },
        { title: 'Canhoto da Nota' },
        { title: 'Histórico' },
        { title: 'Importar Volume' },
        { title: 'Alterar Data de Finalização' }
      ];
      const dataNotPaid = [
        { title: 'Atualizar Status' },
        { title: 'Anexos' },
        { title: 'Canhoto da Nota' },
        { title: 'Histórico' },
        { title: 'Importar Volume' }
      ];

      return item.data.completionDate != '01/01/1' ? dataPaid : dataNotPaid;
    },
    itemsDropdownNfeFast(item) {
      const dataPaid = [
        { title: 'Atualizar Status' },
        { title: 'Anexos' },
        { title: 'Canhoto da Nota' },
        { title: 'Histórico' },
        { title: 'Importar Volume' },
        { title: 'Ver Detalhes' },
        { title: 'Alterar Data de Finalização' }
      ];
      const dataNotPaid = [
        { title: 'Atualizar Status' },
        { title: 'Anexos' },
        { title: 'Canhoto da Nota' },
        { title: 'Histórico' },
        { title: 'Importar Volume' },
        { title: 'Ver Detalhes' }
      ];

      return item.data.completionDate != '01/01/1' ? dataPaid : dataNotPaid;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-file-input__text {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-wrap: wrap;
  top: -7px !important;
  position: relative !important;
  left: 165px !important;
  width: auto !important;
}

.image-container {
  width: 100% !important;
}

::v-deep.v-select.v-select--chips .v-select__selections {
  min-height: 50px;
}
::v-deep .v-pagination.v-pagination {
  justify-content: start;
  position: inherit;
  width: auto;
}
</style>
